import { Editor, Path } from 'slate'

import { CustomEditor } from '../interface/custom-types'

import { isList, isListItem } from './listHelpers/isListHelper'

export const isFirstChildSelectedHelper = (editor: CustomEditor) => {
  const [...parents] = Editor.nodes(editor, {
    match: isList,
    mode: 'highest',
  })

  const [...selectedListItems] = Editor.nodes(editor, {
    match: isListItem,
  })

  const isFirstChildSelected = parents.some(([, listPath]) => {
    return selectedListItems.some(([, listItemPath]) => {
      return Path.equals(listItemPath, [...listPath, 0])
    })
  })

  return isFirstChildSelected
}
